export const DEFAULT_TIMEOUT = 5000;
